import React from 'react'
import './index.sass'

const Sparkline = ({ data = [], color = '#2FA766' }) => {
  const isPositive = color === '#2FA766'
  const gradientId = isPositive ? 'sparklineGradientGreen' : 'sparklineGradientRed'
  const gradientColor = isPositive ? '#1D9B86' : '#E2464A'
  const gradientOpacity = isPositive ? '0.2' : '0.1'

  const lineStyle = {
    stroke: color,
    strokeWidth: 2,
    fill: 'none',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }
  
  const width = 120
  const height = 40

  if (!data || data.length === 0) {
    return (
      <svg
        className="markets-table-sparkline"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
      />
    )
  }

  try {
    const validData = data.filter(d => typeof d === 'number' && !isNaN(d))
    
    if (validData.length === 0) {
      return (
        <svg
          className="markets-table-sparkline"
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          preserveAspectRatio="none"
        />
      )
    }

    const smoothData = (data, windowSize = 2) => {
      return data.map((value, index) => {
        const start = Math.max(0, index - windowSize)
        const end = Math.min(data.length - 1, index + windowSize)
        const window = data.slice(start, end + 1)
        return window.reduce((a, b) => a + b, 0) / window.length
      })
    }

    const smoothedData = smoothData(validData, 1)

    const min = Math.min(...smoothedData)
    const max = Math.max(...smoothedData)
    const diff = max - min || 1

    const points = smoothedData.map((value, index) => {
      const x = (index / (smoothedData.length - 1 || 1)) * width
      const y = height - ((value - min) / diff) * height
      return { x, y, value }
    })

    const createSmoothPath = (points) => {
      if (points.length < 2) return ''
      
      let path = `M${points[0].x},${points[0].y}`
      
      for (let i = 1; i < points.length - 1; i++) {
        const x = (points[i].x + points[i + 1].x) / 2
        const y = (points[i].y + points[i + 1].y) / 2
        path += ` Q${points[i].x},${points[i].y} ${x},${y}`
      }
      
      const last = points[points.length - 1]
      path += ` L${last.x},${last.y}`
      
      return path
    }

    const smoothPath = createSmoothPath(points)
    const areaPath = `${smoothPath} V${height} L${points[0].x},${height} Z`

    return (
      <svg
        className="markets-table-sparkline"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient
            id={gradientId}
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop offset="0%" stopColor={gradientColor} stopOpacity={gradientOpacity} />
            <stop offset="100%" stopColor={gradientColor} stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d={areaPath}
          fill={`url(#${gradientId})`}
        />
        <path
          d={smoothPath}
          fill="none"
          style={lineStyle}
        />
      </svg>
    )
  } catch (error) {
    console.error('Error rendering sparkline:', error)
    return null
  }
}

export default Sparkline

